module.exports = __webpack_public_path__ + "media/images/plans/online/main-c865dfc6630ef9cc08e2b1fa60b454ab.jpg";